import React, { Component } from 'react';

export default class CSVDownloadMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      loading: false,
    };
    this.dropdown = React.createRef();
    this.openDropdownButton = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('click', (e) => this.closeDropdown(e));
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('click', (e) => this.closeDropdown(e));
  }

  closeDropdown = (e) => {
    if (
      !this.dropdown?.current?.contains(e.target) &&
      !this.openDropdownButton?.current?.contains(e.target) &&
      e.target.id !== `${this.props.filename}-hidden-download-link`
    ) {
      if (this._isMounted) {
        this.setState({ showMenu: false });
      }
    }
  };

  setShowMenu = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showMenu: !prevState.showMenu,
      };
    });
  };

  async downloadCsv() {
    try {
      this.setState({ loading: true });
      const csvData = await this.props.csv();

      // https://stackoverflow.com/a/24643992
      const downloadLink = document.createElement('a');
      const blob = new Blob(['\ufeff', csvData]);
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `${this.props.filename}.csv`;
      downloadLink.id = `${this.props.filename}-hidden-download-link`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (e) {
      console.log(`Error when downloading CSV: ${e}`);
    } finally {
      this.setState({ loading: false });
    }
  }

  menu = () => (
    <div className="dropdown-menu" role="menu">
      <div className="dropdown-content">
        <div
          key="download-csv"
          className="dropdown-item csv-menu-item"
          ref={this.dropdown}
          role="menuitem"
          tabIndex="0"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.downloadCsv();
          }}
          onClick={() => this.downloadCsv()}
        >
          {this.state.loading ? 'Downloading...' : 'Download CSV'}
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <div className="dropdown is-active is-right">
        <div className="dropdown-trigger">
          <button
            data-cy="download-csv-menu"
            type="button"
            className="download-csv-menu"
            id={`download-csv-menu-${this.props.filename}`}
            ref={this.openDropdownButton}
            onClick={() => this.setShowMenu()}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.setShowMenu();
            }}
            aria-label="drop down menu"
          >
            <span>•••</span>
          </button>
        </div>
        {this.state.showMenu ? this.menu() : null}
      </div>
    );
  }
}
